import { render, staticRenderFns } from "./TegolaLogo.vue?vue&type=template&id=37f71ac6&scoped=true&"
var script = {}
import style0 from "./TegolaLogo.vue?vue&type=style&index=0&id=37f71ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f71ac6",
  null
  
)

export default component.exports